export const getFirstLetter = (str) => {
  const matched = str.match(/(?<=\s|^)[a-z]/gi);
  if (!matched) return '-';
  return matched.join('');
};
